<template>
  <section class="section-hero">
    <div class="hero container" >
      <div class="hero-content">
        <h1 class="heading-primary">
          {{$t('home.heading')}}
        </h1>
        <p class="hero-description" v-html="$t('home.description')">
        </p>
        <button @click="goToSignup" style="display:flex;flex-direction:column;">
          <span>{{$t('home.Try for Free')}} &rarr;</span>
          <!-- <span style="font-size:x-small;">No credit card required</span> -->
          <!-- <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 74 74"
          >
            <path
              fill="white"
              d="M25 35.5C24.1716 35.5 23.5 36.1716 23.5 37C23.5 37.8284 24.1716 38.5 25 38.5V35.5ZM49.0607 38.0607C49.6464 37.4749 49.6464 36.5251 49.0607 35.9393L39.5147 26.3934C38.9289 25.8076 37.9792 25.8076 37.3934 26.3934C36.8076 26.9792 36.8076 27.9289 37.3934 28.5147L45.8787 37L37.3934 45.4853C36.8076 46.0711 36.8076 47.0208 37.3934 47.6066C37.9792 48.1924 38.9289 48.1924 39.5147 47.6066L49.0607 38.0607ZM25 38.5L48 38.5V35.5L25 35.5V38.5Z"
            ></path>
          </svg> -->
        </button>

        <div class="join-flex" style="flex-direction:column">
          
        </div>
      </div>
      
      
      <home-journey-carousel></home-journey-carousel>
      <div class="section-header" style="margin-top:2rem;">
         <!-- <span class="subheading">{{$t("tests.title")}}</span> -->
          <!-- <h2 class="heading-secondary"> </h2> -->
          <p class="heading-text" >
            <center>Trusted by student clubs, investment communities and users just like you.</center>
          </p>
        </div>
        <div class="testimonials-container" style="margin-top:1rem;margin-bottom:5rem;">
              <img class="testimonial-img" src="../../assets/qtrade.png" />
              <img class="testimonial-img" src="../../assets/ivey.jpg" />
              
              <img class="testimonial-img" src="../../assets/odette.png" />
              
              <img class="testimonial-img" src="../../assets/gsic.png" />
              <img class="testimonial-img" src="../../assets/investa.png" />
               <img class="testimonial-img" src="../../assets/bishops.png" />
              <img class="testimonial-img" src="../../assets/diyinvestor.png" />
              <img class="testimonial-img" src="../../assets/nick.jpg" />
             
              
              <img class="testimonial-img" src="../../assets/outlaw.png" />
              
              <img class="testimonial-img" src="../../assets/julie.jpg" />
             
              <img class="testimonial-img" src="../../assets/owen.jpg" />
             
              <img class="testimonial-img" src="../../assets/kamil.jpg" />
              
            
          

        </div>

      <promo-spot></promo-spot>
    </div>
  </section>
</template>

<script>
import HomeJourneyCarousel from "../learnByDoing/HomeJourneyCarousel.vue";

import { SIGNUP_URL } from "../../config.js";

//import APIService from "../../APIService";
import PromoSpot from './PromoSpot.vue';

//const LAST_COUNT = 12327;

export default {
  data() {
    return {
      heroSection: "",
      heroContent: "",
      obsOptionsHero: {
        root: null,
        threshold: 0.1,
      },
      currentUserCount: null
    };
  },
  mounted() {
  /*
    APIService.get('/user/count').then(resp => {
        if( resp.data.status == "success") {
          this.currentUserCount = resp.data.theCount;
        } else {
          this.currentUserCount = LAST_COUNT;
        }

        this.$nextTick(() => {
          if( this.$refs.userCounter){
            this.$refs.userCounter.start();
          }
        })
        
      }).catch(err => {
        this.currentUserCount = LAST_COUNT;
        console.log(err);
        this.$nextTick(() => {
          if( this.$refs.userCounter){
            this.$refs.userCounter.start();
          }
        })
      });
      */

    this.heroSection = document.querySelector(".section-hero");
    this.heroContent = document.querySelector(".hero-content");
    // const heroObserver = new IntersectionObserver(
    //   this.revealHero,
    //   this.obsOptionsHero
    // );
    // heroObserver.observe(this.heroSection);
  },
  methods: {
    revealHeroContent() {
      this.heroContent.classList.remove("hidden-content");
    },
    revealHero() {
      this.revealHeroContent();
    },
    goToSignup() {
      window.location.href = SIGNUP_URL;
    }
  },

  components: {
    "home-journey-carousel": HomeJourneyCarousel,
    "promo-spot": PromoSpot
  },
};
</script>

<style scoped>

.heading-text{
  font-size: 1.8rem;
}
.testimonial-img {
  height: 4rem;
  margin-right: 1.2rem;
  border-radius: 50%;
}
.testimonials-container {
  position: relative;
  /* height: 36rem; */
  text-align: center;
}

.section-hero {
  position: relative;
  padding: 9.6rem 0 9.6rem 0;
  background: linear-gradient(130deg, #fff 0%, #edfff8 70%, #e0f6ed 80%);
  transform: skewY(3deg);
}

.hero {
  /* max-width: 130rem; */
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transform: skewY(-3deg);
  position: relative;
  width: 100% !important;
  max-width: none;
}

.hidden-content {
  transform: translateY(9.6rem);
  opacity: 0;
}

.hero-content {
  transition: all 0.3s ease-in;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  margin-top:1rem;
}

.heading-primary {
  text-align: center;
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-size: 3rem;
}

.hero-description {
  line-height: 1.6;
  margin-bottom: 2.4rem;
  max-width: 100rem;
  color: #333;
  text-align: center;
}

.join-flex {
  margin-top: 2.4rem;
  display: flex;
  align-items: center;
}

.join-users {
  display: flex;
  margin-right: 1.6rem;
}

.join-users img {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  border: 3px solid #edfff8;
  margin-right: -0.8rem;
}

.join-text {
  font-size: 1.8rem;
  font-weight: 600;
}

.join-text > span {
  color: rgb(105, 59, 245, 1);
  font-weight: 700;
}

button {
  font-family: inherit;
  cursor: pointer;
  font-weight: 500;
  color: #fff;
  transition: all 0.2s;
  padding: 10px 20px;
  border-radius: 0.8rem;
  background-image: linear-gradient(
    to right,
    rgb(105, 59, 245, 1),
    rgb(105, 59, 245, 0.85),
    rgb(105, 59, 245, 0.7)
  );
  border: 1px solid transparent;
  display: flex;
  align-items: center;
  font-size: 2rem;
}

button:hover {
  box-shadow: 0 0.4rem 3.2rem rgb(105, 59, 245, 0.6);
  transform: scale(1.05);
}

button > svg {
  width: 3.6rem;
  margin-left: 1rem;
  transition: transform 0.3s ease-in-out;
  font-weight: 700;
}

button:hover svg {
  transform: translateX(5px);
}

button:active {
  transform: scale(0.95);
}

/* **************************** */
/* BELOW 1360px (Small desktop/laptop) */
/* **************************** */
@media (max-width: 85em) {
  .hero {
    max-width: 120rem;
  }

  /* .heading-primary {
    font-size: 6rem;
  } */
}

/* **************************** */
/* BELOW 976px (landscape tablets) */
/* **************************** */
@media (max-width: 61em) {
  /* .heading-primary {
    font-size: 5.6rem;
  } */
}

/* **************************** */
/* BELOW 800px (tablet) */
/* **************************** */
@media (max-width: 50em) {
  .hero-content {
    width: 80%;
  }

}

/* **************************** */
/* BELOW 592px (mobile) */
/* **************************** */
@media (max-width: 37em) {
  .heading-primary {
    font-size: 3rem;
  }

  .hero-description {
    width: 100%;
  }
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
  /* .heading-primary {
    font-size: 4.4rem;
  } */

  .hero-content {
    width: 100%;
  }

  button {
    padding: 8px 16px;
  }
}
</style>
